import { httpclient } from '@/api/brainstorm/client';

export const stopChat = (chatId) => httpclient.post('/stop', { chatId });
